import { WithUserRoleObject } from 'helpers/misc';
import { isDefined } from 'shared/domain/role/isDefined';
import { isStandard } from 'shared/domain/role/isStandard';
import { isViewer } from 'shared/domain/role/isViewer';

export function accessForAllRoles(): boolean {
  return true;
}

type AccessPredicate = (user: WithUserRoleObject) => boolean;

export function customAccessFunction(callback: AccessPredicate): AccessPredicate {
  return callback;
}

export function accessAtLeastManager(user: WithUserRoleObject): boolean {
  return (
    isDefined(user.role) && !isStandard(user.role) && !isViewer(user.role)
  );
}
